import { render, staticRenderFns } from "./contactContents.vue?vue&type=template&id=da54bcde&scoped=true&"
import script from "./contactContents.vue?vue&type=script&lang=js&"
export * from "./contactContents.vue?vue&type=script&lang=js&"
import style0 from "./contactContents.vue?vue&type=style&index=0&id=da54bcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da54bcde",
  null
  
)

component.options.__file = "contactContents.vue"
export default component.exports